@if (entries && entries.length) {
  <div class="am-flex-align gap-auto ml-m mr-m">
    <div class="am-flex-align am-flex-column mba tablet-hide">
      <span class="height-35 width-110 am-flex-center color-blue text-m">{{title}}:</span>
      @if (canShowMore) {
        <span class="am-flex-column am-flex-align gap-xxs">
          <span class="hover-active b-grey pt-xxs pb-xxs pl-xs pr-xs font-s" (click)="openPopup()">Alle anzeigen</span>
          @if (user.isInternal) { <span class="font-xs">({{ pillsActiveLength() }} ausgewählt)</span> }
        </span>
      }
    </div>
    <ul class="am-flex-wrap gap-s text-s">
      @for (pill of getMainMenuPills(); track pill) {
        <li class="am-flex-center pl-m b-grey entry-pill" [class.disabled]="pill.disabled" [class.active]="pill.active" [class.pr-m]="getMainMenuPills().length < 2 || entries.length <= 4" (click)="togglePill(pill)">
          <span>{{ pill.label }}</span>
          @if (getMainMenuPills().length > 1 && entries.length > 4) { <span class="am-flex-center p-s icon-cross" (click)="removePill($event, pill)"></span> }
        </li>
      }
    </ul>
  </div>
}
